import { api } from 'src/common/axiosInstance';
import { ALL, API_URL, CALL, COMMENT, DASBOARDSUMMARY, DOWNLOADCSV, DOWNLOADTRANSCRIPT, GETBOOKINGDATA, GETCALLDETAILBYID, GETCONVERSATIONDETAILBYID, REBOOK, RESTARTAGENT, UPDATEBOOKINGDATA, UPDATEREASONSTATUS } from 'src/common/constants';
import { handleErrors } from 'src/common/utils';

const BASEAPI_URL = API_URL + CALL;
const RESTART_AGENT_URL = API_URL;
// api functions

export const apiGetAllCall = async (data: { pageLimit: number, pageNumber: number, searchVal: string }) => {
    try {
        const response = await api.get(`${BASEAPI_URL}/${ALL}`, {
            params: {
                pageNumber: data.pageNumber,
                limit: data.pageLimit,
                searchVal: data.searchVal
            },
            headers: { 'Content-Type': 'application/json' },
        });
        return response;
    }
    catch (error) {
        throw new Error(handleErrors(error));
    }
}

export const apiGetCallDetailById = async (data: any) => {
    const newHeader = {
        "Content-type": "application/json"
    }
    try {
        const response = await api.get(`${BASEAPI_URL}/${GETCALLDETAILBYID}?id=${data.id}`, {
            headers: newHeader
        });
        return response;
    }
    catch (error) {
        throw new Error(handleErrors(error));
    }
}

export const apiGetConverstaionDetailById = async (data: any) => {
    const newHeader = {
        "Content-type": "application/json"
    }
    try {
        const response = await api.get(`${BASEAPI_URL}/${GETCONVERSATIONDETAILBYID}?id=${data.id}`, {
            headers: newHeader
        });
        return response;
    }
    catch (error) {
        throw new Error(handleErrors(error));
    }
}

export const apiRestartAgent = async () => {
    const newHeader = {
        "Content-type": "application/json"
    }
    try {
        const response = await api.post(`${RESTART_AGENT_URL}/${RESTARTAGENT}`, {
            headers: newHeader
        });
        return response;
    }
    catch (error) {
        throw new Error(handleErrors(error));
    }
}

export const apiDownloadReport = async (startDate: any, endDate: any, timezoneOffset: any) => {
    try {
        const response = await api.get(`${BASEAPI_URL}/${DOWNLOADCSV}`, {
            params: {
                startDate: startDate,
                endDate: endDate,
                timezoneOffset: timezoneOffset
            },
            responseType: 'blob',
        });
        return response;
    } catch (error: any) {
        throw new Error(`Error while downloading report: ${error.message}`);
    }
};

export const apiDownloadTranscript = async (callId: string) => {
    try {
        const response = await api.get(`${BASEAPI_URL}/${DOWNLOADTRANSCRIPT}`, {
            params: {
                id: callId,
            },
        });
        return response;
    } catch (error: any) {
        throw new Error(`Error while downloading transcript: ${error.message}`);
    }
};

export const apiUpdateReasonStatus = async (data: any) => {
    try {
        const response = await api.put(`${BASEAPI_URL}/${UPDATEREASONSTATUS}`, {
            data
        });
        return response;
    } catch (error: any) {
        throw new Error(`Error while updating status reason: ${error.message}`);
    }
};

export const apiRebook = async (callId: any) => {
    try {
        const response = await api.post(`${BASEAPI_URL}/${REBOOK}`, {
            callId
        });
        return response;
    } catch (error: any) {
        throw new Error(`Error while Re-book: ${error.message}`);
    }
};

export const apiUpdateComment = async (data: any) => {
    try {
        const response = await api.put(`${BASEAPI_URL}/${COMMENT}`, {
            data
        });
        return response;
    } catch (error: any) {
        throw new Error(`Error while updating comment: ${error.message}`);
    }
};

export const apiGetBookingData = async (callId: any) => {
    try {
        const response = await api.get(`${BASEAPI_URL}/${GETBOOKINGDATA}`, {
            params: {
                call_id: callId,
            },
        });
        return response;
    } catch (error: any) {
        throw new Error(`Error while fetching booking details: ${error.message}`);
    }
};

export const apiUpdatetBookingData = async (callId: string, payload: any) => {
    try {
        const response = await api.put(
            `${BASEAPI_URL}/${UPDATEBOOKINGDATA}`,
            payload,
            {
                params: {
                    call_id: callId,
                },
            }
        );
        return response.data;
    } catch (error: any) {
        throw new Error(`Error while updating booking data: ${error.message}`);
    }
};

export const apiGetDashboardSummary= async () => {
    const newHeader = {
        "Content-type": "application/json"
    }
    try {
        const response = await api.get(`${BASEAPI_URL}/${DASBOARDSUMMARY}`, {
            headers: newHeader
        });
        return response;
    }
    catch (error) {
        throw new Error(handleErrors(error));
    }
}